import React from 'react'
import Skeleton from 'react-loading-skeleton'

function SkeletonTable({columns, rows, headerRow, rowsOnly, rowless, columnStyle}){
    let cols = new Array(columns);
    let rws = new Array(rowless ? 1 : rows);

    for(let i =0; i < columns; i++){
        cols[i] = 0
    }
    for(let i =0; i < rows; i++){
        rws[i] = 0
    }

    const ItemRow = () => rowless ? <>
        {cols.map(() => <td><Skeleton style={columnStyle} /></td>)}    
    </> : <tr>
        {cols.map(() => <td><Skeleton style={columnStyle} /></td>)}
    </tr>
    return (rowsOnly || rowless) ? rws.map(() => <ItemRow />) : <div className="table-responsive">
        <table className="table">
            <thead>
                {headerRow ? headerRow : <ItemRow />}
            </thead>
            <tbody>
                {rws.map(() => <ItemRow />)}
            </tbody>
        </table>
    </div>
}

SkeletonTable.defaultProps = {
    columns: 5,
    rows: 5,
    rowsOnly: false,
    rowless: false,
    headerRow: null,
    columnStyle: {}
}

export default SkeletonTable